import { graphClient } from '../../graph-client'
import {
  CHECK_CREATE_USER_HOST_TASK_SPECIAL_WEEKEND,
  CREATE_USER_HOST_TASK_SPECIAL_WEEKEND,
  GET_USER_HOST_TASK_SPECIAL_WEEKEND,
  GET_USER_HOST_TASK_SPECIAL_WEEKEND_FIRST,
  GET_USERS_HOSTS_TASKS_SPECIALS_WEEKENDS,
} from './gql'

import type {
  CheckCreate,
  Create,
  Get,
  GetFirst,
  GetList,
} from './types'

class UserHostTaskSpecialWeekendService {
  async create(params: Create.Input) {
    const request = await graphClient.request<Create.Output>(
      CREATE_USER_HOST_TASK_SPECIAL_WEEKEND,
      params,
    )
    return request?.createUserHostTaskSpecialWeekend
  }

  async checkCreate(params: CheckCreate.Input) {
    const request = await graphClient.request<CheckCreate.Output>(
      CHECK_CREATE_USER_HOST_TASK_SPECIAL_WEEKEND,
      params,
    )
    return request?.checkCreateUserHostTaskSpecialWeekend
  }

  async get(params: Get.Input) {
    const request = await graphClient.request<Get.Output>(
      GET_USER_HOST_TASK_SPECIAL_WEEKEND,
      params,
    )
    return request?.getUserHostTaskSpecialWeekend
  }

  async getFirst(params: GetFirst.Input) {
    const request = await graphClient.request<GetFirst.Output>(
      GET_USER_HOST_TASK_SPECIAL_WEEKEND_FIRST,
      params,
    )
    return request?.getUserHostTaskSpecialWeekendFirst
  }

  async getList({ take = 20, skip = 0, ...params }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_USERS_HOSTS_TASKS_SPECIALS_WEEKENDS,
      { ...params, skip: take * skip },
    )
    return request?.getUsersHostsTasksSpecialsWeekends
  }
}
export const userHostTaskSpecialWeekendService =
  new UserHostTaskSpecialWeekendService()
